module.exports = __webpack_public_path__ + "img/lmxy_icon.903cdbe6.png";